import { ErrorResponse } from "./types";

export const getErrorMessages = (errorResponse: ErrorResponse) => {
    if (Array.isArray(errorResponse) && errorResponse.length === 1) {
        return errorResponse[0].message;
    }
    return errorResponse?.map((response) => response.message);
};
